var _style, _g, _polyline, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAe4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "904.3px",
    height: "904.3px",
    viewBox: "0 0 904.3 904.3",
    style: {
      enableBackground: "new 0 0 904.3 904.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#3B414F;stroke-width:30;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,151.6h299.1l281.1,214.5c23.9,18.2,35.9,48.2,31,77.9l-27.6,168.4c-6.4,39.3-40.4,68.2-80.3,68.2h-87.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.2,
    y1: 680.7,
    x2: 199.7,
    y2: 680.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 321.8,
    cy: 680.7,
    r: 122.1
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "627.9,581.8 737.5,583.5 801.4,496.3 801.4,496.3 774,651.6 595.2,651.6 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 806,
    cy: 446.1,
    r: 50.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAe4);
export default __webpack_public_path__ + "static/media/ae4.95d9bceb14bc78e0a37775db9d252f96.svg";
export { ForwardRef as ReactComponent };